import {API_PATH} from '../../constants/api-path'
import {ExceptionError} from '../exception'
import {Request} from '../request'

export class SignOutService extends Request {
  async request() {
    try {
      this.client.post(`${API_PATH.AUTHENTICATION}/logout`)
      return true
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
